import React, { useContext } from "react";
import Heading from "./Heading";
import { RiDoubleQuotesL } from "react-icons/ri";
import { CgChevronDoubleRight, CgChevronDoubleLeft } from "react-icons/cg";
import StarRatings from "react-star-ratings";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import TestimonialSkeleton from "../skeletons/TestimonialSkeleton";
import useFetch from "../hooks/useFetch";
import parse from "html-react-parser";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import AnimationContext from "../contexts/animation/AnimationContext";
const Testimonials = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });
  const { setAnimation } = useContext(AnimationContext);
  const inViewVariants = setAnimation(inView);

  const { data: reviews, isLoading } = useFetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/reviews?sort=publishedAt:desc`
  );
  const responsive = {
    lg: {
      breakpoint: { max: 6000, min: 600 },
      items: 2,
    },
    sm: {
      breakpoint: { max: 599, min: 0 },
      items: 1,
    },
  };
  return (
    <section
      ref={ref}
      className="bg-scColor  pb-[20px] sm:pb-[40px] w-full overflow-hidden section"
      id="testimonials"
    >
      <div className="container pt-[40px] sm:pt-[90px]">
        <div className="mb-8 sm:mb-16">
          <Heading title={"Satisfied Clients Say"} subTitle="Testimonials" />
        </div>
      </div>

      <Carousel
        responsive={responsive}
        infinite={false}
        keyBoardControl={true}
        customTransition="transform 500ms ease-in-out"
        transitionDuration={500}
        autoPlaySpeed={8000}
        autoPlay={true}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        itemClass="px-3 md:px-4 xl:px-8 overflow-hidden"
        centerMode={false}
        minimumTouchDrag="20"
      >
        {!isLoading &&
          reviews.map((r, index) => {
            return review(
              `${r.attributes.name}`,
              `${r.attributes.designation}`,
              parse(`${r.attributes.review}`),
              parseFloat(r.attributes.rating),
              index,
              inViewVariants
            );
          })}
        {isLoading && [1, 2].map((n) => <TestimonialSkeleton key={n} />)}
      </Carousel>
    </section>
  );
};
const review = (name, designation, text, rating, index, inViewVariants) => {
  return (
    <motion.div
      variants={inViewVariants}
      initial="hidden"
      animate="visible"
      className="h-fit bg-prColor/80 px-8 py-12 sm:px-12 sm:py-16 flex-shrink-0 flex-grow-0 basis-[100%] md:basis-[48.7%]"
      key={index}
    >
      <RiDoubleQuotesL className="text-dark text-4xl sm:text-6xl mb-4 sm:mb-8" />
      <p className="text-light font-['Merriweather'] text-base xs:text-xl sm:text-2xl md:text-3xl font-light">
        {text}
      </p>
      <div className="flex justify-between items-center mt-4 sm:mt-8">
        <div className="font-['Poppins'] ">
          <h3 className="text-light text-sm xs:text-base md:text-lg">{name}</h3>
          <p className="text-dark text-sm xs:text-base md:text-lg">
            {designation}
          </p>
        </div>
        <div className="flex gap-2">
          <StarRatings
            starDimension="20px"
            starSpacing="3px"
            rating={rating}
            starRatedColor="#FFA217"
          />
        </div>
      </div>
    </motion.div>
  );
};
const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      type="button"
      className="btn-secondary translate-in translate-x-60"
      style={{ right: "calc(4% - 1px)" }}
      onClick={() => onClick()}
    >
      <CgChevronDoubleRight fontSize={22} />
    </button>
  );
};
const CustomLeftArrow = ({ onClick }) => {
  return (
    <button
      type="button"
      className="btn-secondary translate-in -translate-x-60"
      style={{ left: "calc(4% - 1px)" }}
      onClick={() => onClick()}
    >
      <CgChevronDoubleLeft fontSize={22} />
    </button>
  );
};
export default Testimonials;
